export const SERVER: string = "https://weather.dfos.kr:40000";
// export const SERVER: string = "http://223.130.146.157:40000";
// export const SERVER: string = "http://192.168.0.75:40000";
// export const WEATHER_API: string = "http://223.130.146.157:40001/igis";
export const WEATHER_API: string = "https://weather.dfos.kr:40001/igis";
// export const WEATHER_API: string = "http://192.168.0.75:40001/igis";

export const IP_INFO: string = "https://ipapi.co/json";

// keycloak
export const KEYCLOAK_URL: string = "https://www.dfos.kr:8443";
export const KEYCLOAK_CHECK_TOKEN = `${KEYCLOAK_URL}/realms/dfos/protocol/openid-connect/userinfo`;
export const KEYCLOAK_TOKEN = `${KEYCLOAK_URL}/realms/dfos/protocol/openid-connect/token`;
export const GET_USER_INFO: string = `${KEYCLOAK_URL}/realms/dfos/protocol/openid-connect/userinfo`;
export const LOGOUT: string = `${KEYCLOAK_URL}/realms/dfos/protocol/openid-connect/logout`;

// portal
export const PORTAL_SERVER = "https://www.dfos.kr";
export const PORTAL_LOGIN: string = `${PORTAL_SERVER}/login`;

// console
export const CONSOLE_SERVER = "https://www.dfos.kr:30003";
// export const CONSOLE_SERVER = "http://192.168.0.75:30003";
export const GRAPHQL: string = `${CONSOLE_SERVER}/graphql`;
